<template>
  <!-- Add -->
  <b-modal
    id="modalAdd"
    ref="my-modal"
    title="เพิ่มข้อมูลอุปกรณ์"
    size="lg"
    ok-title="ตกลง"
    cancel-title="ยกเลิก"
    @show="resetModal"
    @hidden="resetModal"
    @ok="handleOk"
  >
    <validation-observer ref="simpleRules">
      <b-row>
        <b-col lg="9">
          <b-form-group
            label="สถานที่"
            label-for="contract_no"
          >
            <validation-provider
              #default="{ errors }"
              name="Location"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="location"
                  v-model="addData.location"
                  :state="errors.length > 0 ? false:null"
                  required
                  type="text"
                  placeholder="สถานที่"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group
            label="สายทาง"
            label-for="wayname"
          >
            <validation-provider
              #default="{ errors }"
              name="Route Name"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="pjcode"
                  v-model="addData.wayname"
                  :state="errors.length > 0 ? false:null"
                  required
                  type="text"
                  placeholder="สายทาง"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col lg="4">
          <b-form-group
            label="IP Address"
            label-for="pjname"
          >
            <validation-provider
              #default="{ errors }"
              name="IP Address"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="ipaddress"
                  v-model="addData.ipaddress"
                  :state="errors.length > 0 ? false:null"
                  required
                  type="text"
                  placeholder="IP Address"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col lg="4">
          <b-form-group
            label="ประเภท"
            label-for="department"
          >
            <validation-provider
              #default="{ errors }"
              name="Type Name"
              rules="required"
            >
              <v-select
                v-model="addData.typename"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                required
                label="groupName"
                :options="PCtype"
                placeholder="เลือกประเภท..."
                transition=""
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col lg="4">
          <b-form-group
            label="PC Type"
            label-for="department"
          >
            <validation-provider
              #default="{ errors }"
              name="Department"
              rules="required"
            >
              <v-select
                v-model="addData.pctype"
                :reduce="PCtype => PCtype.groupName"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                required
                label="groupName"
                :options="PCtype"
                placeholder="เลือก PC Type..."
                transition=""
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col lg="4">
          <b-form-group
            label="Anydesk"
            label-for="anydesk"
          >
            <validation-provider
              #default="{ errors }"
              name="anydesk"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="anydesk"
                  v-model="addData.anydesk"
                  :state="errors.length > 0 ? false:null"
                  required
                  type="text"
                  placeholder="Anydesk"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col lg="4">
          <b-form-group
            label="ZT IPAddress"
            label-for="zt ipaddress"
          >
            <validation-provider
              #default="{ errors }"
              name="zt ipaddress"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="zt_ipaddress"
                  v-model="addData.zt_ipaddress"
                  :state="errors.length > 0 ? false:null"
                  required
                  type="text"
                  placeholder="ZT IPAddress"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <template #code>
          {{ codeFeedbackHelper }}
        </template>
      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BFormGroup, BInputGroup, BFormInput,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BInputGroup,
    BFormInput,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      required,
      PCtype: [],
      selectDepartment: [],
      vendor: [],
      road: [],
      date: {
        contract_date: '',
        guarantee_date_start: '',
      },
      addData: {
        wayname: '',
        location: '',
        ipaddress: '',
        typename: '',
        pctype: '',
        anydesk: '',
        zt_ipaddress: '',
        wid: '',
      },
    }
  },
  mounted() {
    this.dropdownPCtype()
  },
  methods: {
    resetModal() {
      this.addData.wayname = ''
      this.addData.location = ''
      this.addData.ipaddress = ''
      this.addData.pctype = ''
      this.addData.typename = ''
      this.addData.anydesk = ''
      this.addData.zt_ipaddress = ''
      this.addData.wid = ''
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      this.addInfo()
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      })
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.validationForm()
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (!success) {
          // eslint-disable-next-line
          return
        }
        this.addInfo()
        this.$nextTick(() => {
          this.$bvModal.hide('modalAdd')
        })
      })
    },
    // เพิ่มข้อมูลปุ่ม Add
    async addInfo() {
      axios
        .post('/addEquipment', this.addData)
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          this.$swal({
            icon: 'success',
            title: '<span style="color:#000000">เพิ่มอุปกรณ์เรียบร้อย.</span>',
            showConfirmButton: false,
            timer: 1000,
          })
          this.$emit('fetch')
          this.resetModal()
        })
        .catch(error => {
          console.log(error.response)
          this.$swal({
            icon: 'error',
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 2000,
          })
        })
    },
    dropdownPCtype() {
      axios
        .post('/dropdownPCtype')
        .then(response => {
          this.PCtype = response.data
        })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
